import { useEffect, useState } from "react";

const STORAGE_KEY = "portfolio-theme";
const META_COLORS = { light: "#FAF9F6", dark: "#15161B" };
const listeners = new Set();

function systemTheme() {
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function getStoredTheme() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch {
    /* storage unavailable */
  }
  return systemTheme();
}

export function applyTheme(theme) {
  document.documentElement.dataset.theme = theme;
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", META_COLORS[theme] || META_COLORS.light);
}

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    const current = document.documentElement.dataset.theme;
    if (current !== "dark" && current !== "light") {
      const resolved = getStoredTheme();
      applyTheme(resolved);
      return resolved;
    }
    return current;
  });

  useEffect(() => {
    const notify = () => setTheme(document.documentElement.dataset.theme || "light");
    listeners.add(notify);
    return () => {
      listeners.delete(notify);
    };
  }, []);

  const toggle = () => {
    const next = document.documentElement.dataset.theme === "dark" ? "light" : "dark";
    applyTheme(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      /* storage unavailable */
    }
    listeners.forEach((fn) => fn());
  };

  return { theme, toggle };
}
